<template>
    <div class="container">
        <b-row>
            <b-col cols="12">
                <h2 class="h1 text-uppercase">{{ $t('nuevo_abono.completa_datos') }}</h2>
                <div class="subtitle h3 light mb-3">{{ $t('nuevo_abono.completa_info', {abono: teatro.texto_abono}) }}</div>
            </b-col>
            <b-col cols="12">
                <ValidationObserver tag="form" ref="observer" @submit.prevent="guardarDatos()">
                    <div v-for="(abono, index) in sesiones" :key="index">
                        <DatosAbono 
                            :abono="abono" 
                            :generos="generos" 
                            :index="++index" 
                            :descuentos="getDescuentos(abono.precio_id)" 
                            :desactivar="false"
                        />
                    </div>
                    <b-col cols="12">
                        <b-row>
                            <b-col cols="auto" class="mr-auto">
                                <button class="button effect-button large-button" type="submit">
                                    Continuar
                                </button>
                            </b-col> 
                            <b-col cols="auto">
                                <button class="button effect-button large-button" @click.prevent="volver">
                                    Volver
                                </button>
                            </b-col>
                        </b-row>
                    </b-col>
                </ValidationObserver>
            </b-col>
        </b-row>            
    </div>
</template>

<script>
    import Generos from "@/mixins/Generos";
    import DatosAbono from "./components/DatosAbono.vue";

    export default {
        mixins: [Generos],
        props: {
            precios: {
                type: Array,
                required: true
            },
            sesiones: {
                type: Array,
                required: true
            },
            session_id: {
                type: String,
                required: true
            }
        },
        computed: {
            teatro(){
                return this.$store.getters.getTeatro
            }
        },
        created() {
            this.sesiones.forEach(abono => {
                abono.tipo_abono = this.precios.find(precio => precio.id == abono.precio_id);
            });

            this.getGeneros();
        },
        methods: {
            getDescuentos(precio_id) {
                return this.precios.find(precio => precio.id == precio_id).descuentos;
            },
            async guardarDatos() {
                const errors = Object.keys(this.$refs.observer.errors).some(
                    field => this.$refs.observer.errors[field].length > 0
                );

                if(errors) {
                    return
                }

                const isValid = await this.$refs.observer.validate();
                const tienen_telefono = this.sesiones.filter(sesion => !isNaN(sesion.telefono) && sesion.telefono != null && sesion.telefono_valido).length === this.sesiones.length;
            
                if (isValid && tienen_telefono) {
                    this.sesiones.forEach(sesion => {
                        sesion.descuento_id = sesion.descuento.id;
                        sesion.sesion_id = sesion.id;
                        sesion.descuento.precio_total = sesion.descuento.price_management_interno ? sesion.descuento.precio : sesion.descuento.precio + sesion.descuento.price_management;
                    });

                    const params = {
                        datos_compradores: this.sesiones,
                        session_id: this.session_id
                    }

                    this.$store.dispatch(this.config.getVuexAlias('front.guardar.datos.abonos.sin.recinto'), params).then(res => {
                        this.$emit('datos-guardados', {
                            'jet_id': res.data.jet_id,
                            'formulario': res.data.formulario,
                            'datos_compradores': this.sesiones
                        });
                    }).catch(error => {
                        this.resumen_error = error.response.data.message;
                        this.resumen_loading = false;
                    });
                }
            },
            volver() {
                this.$emit('volver');
            }
        },
        components: {
            DatosAbono
        }
    }
</script>